export default __webpack_public_path__ + "static/media/2.df68d537.png";